KROWN.saveToSessionStorage = () => {
  const specialInstructionsInput = document.getElementById('cartSpecialInstructions');
  if ( ! specialInstructionsInput ) {
    return;
  }
  const specialInstructions = specialInstructionsInput.value;
  sessionStorage.setItem('cartSpecialInstructions', specialInstructions);
}

const specialInstructionsInput = document.getElementById('cartSpecialInstructions');
if ( specialInstructionsInput ) {
  specialInstructionsInput.addEventListener('input', KROWN.saveToSessionStorage);
}

KROWN.loadFromSessionStorage = () => {
  const specialInstructionsInput = document.getElementById('cartSpecialInstructions');
  if ( ! specialInstructionsInput ) {
    return;
  }
  const savedInstructions = sessionStorage.getItem('cartSpecialInstructions');
  if ( savedInstructions ) {
    specialInstructionsInput.value = savedInstructions;
  }
}
document.addEventListener('DOMContentLoaded', KROWN.loadFromSessionStorage);
